import React, { useEffect, useState, useMemo } from "react";
import HRHeader from "../components/HRHeader";
import api from "../api";
import { Network, Crown, Users, Mail } from "lucide-react";

const DEPT_COLORS = ["#16345c", "#0d6cb8", "#009640", "#8e44ad", "#e67e22", "#c0392b"];

const OrganigrammaPage = () => {
  const [org, setOrg] = useState([]);

  useEffect(() => {
    api.get("/org").then((r) => setOrg(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Precalcola colore e membri (esclude il responsabile) una sola volta per reparto.
  const depts = useMemo(
    () => org.map((d, idx) => ({
      ...d,
      _color: DEPT_COLORS[idx % DEPT_COLORS.length],
      _members: (d.members || []).filter((m) => !d.manager || m.id !== d.manager.id),
    })),
    [org]
  );

  const initials = (name) => (name || "?").split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();

  return (
    <div className="min-h-screen bg-[#f0f2f5]" data-testid="organigramma-page">
      <HRHeader />
      <main className="max-w-[1200px] mx-auto px-4 py-8">
        <h1 className="text-[26px] font-black text-[#16345c] mb-1 flex items-center gap-2"><Network size={24} /> Organigramma</h1>
        <p className="text-[14px] text-gray-500 mb-6">Struttura aziendale, reparti e responsabili del gruppo.</p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5" data-testid="org-grid">
          {depts.map((d) => {
            const color = d._color;
            return (
              <div key={d.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                <div className="px-5 py-4 flex items-center justify-between" style={{ backgroundColor: `${color}12` }}>
                  <div>
                    <div className="text-[17px] font-black" style={{ color }}>{d.name}</div>
                    <div className="text-[12px] text-gray-500 flex items-center gap-1"><Users size={12} /> {d.members_count} {d.members_count === 1 ? "persona" : "persone"}</div>
                  </div>
                  <span className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}1f`, color }}><Network size={20} /></span>
                </div>

                <div className="p-4">
                  {d.manager ? (
                    <div className="flex items-center gap-3 mb-3 pb-3 border-b border-gray-100">
                      <span className="w-11 h-11 rounded-full text-white flex items-center justify-center text-[14px] font-bold shrink-0" style={{ backgroundColor: color }}>{initials(d.manager.name)}</span>
                      <div className="min-w-0">
                        <div className="text-[14px] font-bold text-[#16345c] flex items-center gap-1">{d.manager.name} <Crown size={13} className="text-amber-500" /></div>
                        <div className="text-[12px] text-gray-500">{d.manager.job_title || "Responsabile"}</div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-[12.5px] text-gray-400 italic mb-3 pb-3 border-b border-gray-100">Nessun responsabile assegnato</div>
                  )}

                  <div className="space-y-2">
                    {d._members.map((m) => (
                      <div key={m.id} className="flex items-center gap-3">
                        <span className="w-8 h-8 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center text-[11px] font-bold shrink-0">{initials(m.name)}</span>
                        <div className="min-w-0 flex-1">
                          <div className="text-[13px] font-semibold text-gray-800 truncate">{m.name}</div>
                          <div className="text-[11.5px] text-gray-500 truncate">{m.job_title}</div>
                        </div>
                        {m.email && <a href={`mailto:${m.email}`} className="text-gray-400 hover:text-[#0d6cb8] shrink-0"><Mail size={14} /></a>}
                      </div>
                    ))}
                    {d._members.length === 0 && (
                      <div className="text-[12.5px] text-gray-400 italic">Nessun membro nel reparto</div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
};

export default OrganigrammaPage;
